import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BrandBgEntity, BrandBgEntityRaw } from "@common/domain";
import { ApiService } from "@youm-front/api/data-access";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  RoomBrandBgCreateRequestDTO,
  RoomBrandBgCreateResponseDTO,
  RoomBrandBgDeleteRequestDTO,
  RoomBrandBgDeleteResponseDTO,
  RoomBrandBgUnUseRequestDTO,
  RoomBrandBgUseRequestDTO
} from "../dto";

@Injectable()
export class RoomBrandBgService {
  constructor(private readonly apiService: ApiService) {}

  roomBrandBgCreate(
    roomBrandBgCreateRequestDTO: RoomBrandBgCreateRequestDTO
  ): Observable<RoomBrandBgCreateResponseDTO> {
    const formData = new FormData();

    formData.set("bg", roomBrandBgCreateRequestDTO.data.data);
    formData.set("width", roomBrandBgCreateRequestDTO.data.width + "");
    formData.set("height", roomBrandBgCreateRequestDTO.data.height + "");

    return this.apiService
      .post<{ brandBg: BrandBgEntityRaw }>(
        `rooms/${roomBrandBgCreateRequestDTO.data.roomId}/brands/${roomBrandBgCreateRequestDTO.data.brandId}/bgs`,
        formData,
        "v1",
        new HttpHeaders().set("Content-Type", "multipart/form-data")
      )
      .pipe(
        map(
          (_) =>
            new RoomBrandBgCreateResponseDTO({
              brandBg: new BrandBgEntity(_.brandBg)
            })
        )
      );
  }

  roomBrandBgDelete(
    roomBrandBgDeleteRequestDTO: RoomBrandBgDeleteRequestDTO
  ): Observable<RoomBrandBgDeleteResponseDTO> {
    return this.apiService
      .delete(
        `rooms/${roomBrandBgDeleteRequestDTO.data.roomId}/brands/${roomBrandBgDeleteRequestDTO.data.brandBg.value.brandId}/bgs/${roomBrandBgDeleteRequestDTO.data.brandBg.value.id}`
      )
      .pipe(
        map(
          () =>
            new RoomBrandBgDeleteResponseDTO({
              roomId: roomBrandBgDeleteRequestDTO.data.roomId,
              brandBg: roomBrandBgDeleteRequestDTO.data.brandBg
            })
        )
      );
  }

  roomBrandBgUnUse(
    roomBrandBgUnUseRequestDTO: RoomBrandBgUnUseRequestDTO
  ): Observable<void> {
    return this.apiService.delete<void>(
      `rooms/${roomBrandBgUnUseRequestDTO.data.roomId}/brands/${roomBrandBgUnUseRequestDTO.data.brandBg.value.brandId}/bgs/${roomBrandBgUnUseRequestDTO.data.brandBg.value.id}/use`
    );
  }

  roomBrandBgUse(
    roomBrandBgUseRequestDTO: RoomBrandBgUseRequestDTO
  ): Observable<void> {
    return this.apiService.post<void>(
      `rooms/${roomBrandBgUseRequestDTO.data.roomId}/brands/${roomBrandBgUseRequestDTO.data.brandBg.value.brandId}/bgs/${roomBrandBgUseRequestDTO.data.brandBg.value.id}/use`,
      {}
    );
  }
}
